import { inject } from '@angular/core';

import { SonaAuthApiFacade } from '../facades/auth-api.facade';

import type { Feature } from '@sona/shared-model-common';

export const usePermission = (permission: Feature) => {
    const facade = inject(SonaAuthApiFacade);

    return facade.hasPermission(permission);
};
